import { render, staticRenderFns } from "./agent.vue?vue&type=template&id=686ba705&scoped=true&"
var script = {}
import style0 from "./agent.vue?vue&type=style&index=0&id=686ba705&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686ba705",
  null
  
)

export default component.exports